function numericMessageId(id) {
  if (id == null || id === '') return null;
  if (typeof id === 'number' && Number.isFinite(id)) return id;
  const text = String(id);
  const prefixed = text.match(/^tenant_(\d+)$/);
  if (prefixed) return Number(prefixed[1]);
  if (!/^\d+$/.test(text)) return null;
  return Number(text);
}

function lastTenantMessageId(messages) {
  let max = null;
  for (const msg of messages || []) {
    const id = numericMessageId(msg && msg.id);
    if (id == null) continue;
    if (max == null || id > max) max = id;
  }
  return max;
}

function isTenantIssueResolved(lastId, resolvedMessageId) {
  const last = numericMessageId(lastId);
  const resolved = numericMessageId(resolvedMessageId);
  return last != null && resolved != null && last === resolved;
}

function visibleTenantMessages(messages, { resolvedMessageId, expanded } = {}) {
  const rows = messages || [];
  const resolved = numericMessageId(resolvedMessageId);
  if (resolved == null || expanded) return rows;
  return rows.filter((msg) => {
    const id = numericMessageId(msg && msg.id);
    return id == null || id > resolved;
  });
}

module.exports = {
  numericMessageId,
  lastTenantMessageId,
  isTenantIssueResolved,
  visibleTenantMessages,
};
